// App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './components/dashboard/dashboard.js';
import Login from './components/login/login.js';
// import Add_Customer_Page from './components/Admin_Side/Add_Customer/Add_Customer_Page';
// import Add_Contract_Page from "./components/Admin_Side/Add_Contract/Add_Contract.js";
// import Add_Admin from './components/Admin_Side/Add_Admin/Add_Admin.js';
// import Add_User from './components/Admin_Side/Add_User.js';
// import View_Edit_Contract_Page from './components/Admin_Side/Edit_Contract/View_Edit_Contract.js';
// import LoginPage from './components/Login/Login_Page.js';
// import CustomerDashboardPage from './components/Customer_Side/Customer_Dashboard/DashboardPage.js';
// import EditProfilePage from './components/Customer_Side/Edit_Password/Edit_Profile.js';
// import View_Contract from './components/Customer_Side/View_Contract/View_Contract.js';
// import ViewUsers from './components/View_Users.js';
// import SummaryTable from './components/Admin_Side/Dashboard/TableSummary.js';
// import View_Edit_Customer_Page from './components/Admin_Side/Company_Profile/View_Edit_Customer.js';
// import Add_Customer_Admin from './components/Admin_Side/Add_Customer/Add_Customer_Page';
// import AddViewerForm from './components/Admin_Side/User_Managment/Add_Customer_Viewer.js';
// import View_Customer_Viewer from './components/Admin_Side/User_Managment/View_Customer_Viewer.js';
// import EditCustomerPage from './components/Admin_Side/Company_Profile/Edit_Customer.js';
// import EditContract from './components/Admin_Side/Edit_Contract/Edit_Contract.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;



